import React, { useEffect, useState } from "react";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import FooterSection from "../component/layout/footer";

function DataProtectionPolicy() {
  return (
    <div>
      <Header />
      <div className="contact-section">
        <div
          className="contact-top padding-tb aside-bg"
          style={{
            "margin-left": "20px",
            "margin-right": "20px",
            "padding-top": "200px",
          }}
        >
          <div className="vc_row wpb_row vc_row-fluid vc_custom_1497013187222">
            <div className="row-container vc_row-flex row-default vc_row">
              <div className="wpb_column vc_column_container vc_col-sm-12">
                <div className="vc_column-inner ">
                  <div className="wpb_wrapper policy-wrapper">
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <h2>Data Protection Policy</h2>
                      </div>
                    </div>

                    <div class="wpb_text_column wpb_content_element ">
                      <div class="wpb_wrapper">
                        <p>
                          This Data Protection Policy outlines how Tegal app
                          collects, processes, and protects the personal data of
                          our users, in accordance with the Nigerian Data
                          Protection Act 2023 (NDPA) and relevant regulations.
                        </p>

                        <h2>Key Definitions</h2>
                        <ul>
                          <li>
                            <b>Personal Data:</b> Any information relating to an
                            identifiable individual, including but not limited
                            to name, email address, phone number, location data,
                            and financial information.
                          </li>
                          <li>
                            <b>Data Subject:</b> An individual whose personal
                            data is processed by Tegal app.
                          </li>
                          <li>
                            <b>Data Controller:</b> The entity responsible for
                            determining the purposes and means of processing
                            personal data.
                          </li>
                          <li>
                            <b>Data Processor:</b> An entity that processes
                            personal data on behalf of a data controller.
                          </li>
                        </ul>

                        <h2>Data Collection and Usage</h2>
                        <ul>
                          <li>
                            <b>Lawful Basis for Processing:</b> We will only
                            collect and process personal data when we have a
                            lawful basis to do so, such as consent, contractual
                            necessity, or legitimate business interests.
                          </li>
                          <li>
                            <b>Transparency:</b> We will clearly inform data
                            subjects about the purpose of collecting their data,
                            how it will be used, and their rights regarding
                            their data.
                          </li>
                          <li>
                            <b>Data Minimization:</b> We will only collect and
                            process the minimum amount of personal data
                            necessary to achieve the intended purpose.
                          </li>
                        </ul>

                        <h2>Data Subject Rights</h2>
                        <ul>
                          <li>
                            <b>Right to Access:</b> Data subjects have the right
                            to access their personal data held by us upon
                            request.
                          </li>
                          <li>
                            <b>Right to Rectification:</b> Data subjects can
                            request correction of any inaccurate personal data.
                          </li>
                          <li>
                            <b>Right to Erasure:</b> In certain circumstances,
                            data subjects can request the deletion of their
                            personal data.
                          </li>
                          <li>
                            <b>Right to Object:</b> Data subjects can object to
                            the processing of their personal data in certain
                            situations.
                          </li>
                        </ul>

                        <h2>Data Security</h2>
                        <ul>
                          <li>
                            <b>Appropriate Safeguards:</b> We implement
                            appropriate technical and organizational measures to
                            protect personal data from unauthorized access, use,
                            disclosure, alteration, or destruction.
                          </li>
                          <li>
                            <b>Data Breach Notification:</b> In the event of a
                            data breach, we will take immediate steps to notify
                            affected data subjects and the relevant regulatory
                            authorities.
                          </li>
                        </ul>

                        <h2>Third-Party Sharing</h2>
                        <p>
                          We may share personal data with trusted third-party
                          service providers who assist us in operating our
                          business, but only where necessary and with
                          appropriate safeguards in place to protect data
                          privacy.
                        </p>

                        <h2>Contact Information</h2>
                        <p>
                          For any questions regarding our Data Protection
                          Policy, please contact us at [email protected]
                        </p>

                        <p>
                          <b>Last Updated:</b> Dec 15 2024
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterSection />
    </div>
  );
}

export default DataProtectionPolicy;
